<template>
    <v-sheet v-if="showPrimaryGraph" :class="xs?'card-dialogs-graph-wop':'card-dialogs-graph'" class="defaultCard" color="bgtopology">
        <v-row class="mx-2" justify='center'>
            <v-col class="pa-0 py-4"  style="max-width: 100%">
                <v-sheet  class="text-center" color="transparent"   v-if="showTUM">
                    <SingleCard 
                    :colorIcon="getColorStatus(status??'superdown')"
                    :middleText="name"
                    :bottomText="ip"
                    :isTopology="true"
                    :typeItem="typesel"
                    :model="model"
                    />

                    <GaugeComponent
                    v-if="finalItemOperability"
                    :recharge="false"
                    :array-items="finalItemOperability"
                    />
                </v-sheet>
            </v-col>

            <v-sheet color='transparent' class="ml-2" :style="smAndDown ? 'width: 100%' : 'width: calc(100% - 428px);'" style="align-content: center;">
                <SingleChart v-if="arrayValues.length !== 0" :name="'Latency'" :first-array="arrayValues" :title=" t('labels.latency')" color="#F6E5E5"/>
                <v-sheet v-else class="text-center" color="transparent">
                    <Prog_circular />
                </v-sheet>
            </v-sheet>
        </v-row>
    </v-sheet>
</template>

<script setup lang="ts">
import { Ref, ref, onMounted } from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs, smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
import GaugeComponent from '@/components/SmartLink/dashboard/GaugeComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleCard from '@/components/SmartLink/topology/SingleCard.vue';
import SingleChart from '@/components/SmartLink/charts/SingleChart.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS,STATUS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getCambiumDataByIp, getOperabilityByIp } from '@/services/Smartlink/Graphs';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();


const props = defineProps({
    ip          : { required:true, type:String },
    typesel     : { required:true, type:String },
    name        : { required:true, type:String },
    status      : { type:String},
    model      : { type:String}
})
        

const params = { 
    ip      : props.ip,
    type    : 'latency',

};

/**
 * Variable para mostrar la gráfica del IEO y SINGLECARD, se oculta por completo si no hay DATOS desde la API
 */
const showTUM               = ref(false);
const finalItemOperability  = ref();

/**
 * Consulta a la API: "getAllOperabilityByIP"
 * Envia como parámetro la IP
 */
async function getOperability() {
    
    const allData = await getOperabilityByIp(params)
    
    if( allData.status === 400 ){
        showTUM.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showTUM.value = allData.showGraphs
        finalItemOperability.value = allData.data
    }

}


const arrayValues:Ref<number[][]>   = ref([]);

/**
 * Variable para mostrar los gráficos, se oculta por completo si no hay DATOS desde la API
 */
const showPrimaryGraph              = ref(true);

/**
 * Consulta a la API: "getGraphTopologyData"
 * envía como parámetro la ip y el tipo de pedido
 * (latency, cambium_data, linkradiohoriz)
 */
async function getDataGraph() {

    const allData = await getCambiumDataByIp(params)

    if( allData.status === 400 ){
        showPrimaryGraph.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showPrimaryGraph.value = allData.showGraphs
        arrayValues.value = allData.data
    }

}

/**
 * Regresa el color, de acuerdo al estado del equipo
 * @param estado 
 */
const getColorStatus = (estado:string) => {
    let finalColorStatus = COLOR.greyfake;

    if(estado.toUpperCase() === STATUS.ok)      finalColorStatus = COLOR.green;
    if(estado.toUpperCase() === STATUS.alert)   finalColorStatus = COLOR.yellow;
    if(estado.toUpperCase() === STATUS.alarm)   finalColorStatus = COLOR.red;
    if(estado.toUpperCase() === STATUS.down)    finalColorStatus = COLOR.greyfake;

    return finalColorStatus
}

onMounted( async() => {
    getOperability();
    getDataGraph();
})


</script>